import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { WorkspaceStoreEffects } from './effects';
import { workspacesReducer } from './reducer';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature('workspaces', workspacesReducer), EffectsModule.forFeature([WorkspaceStoreEffects])],
  providers: [WorkspaceStoreEffects],
})
export class WorkspacesStoreModule {
  workspace: any;
}

export class WorkspaceVaultsStoreModule {
  workspaceVaults: any;
}
